const featuredArticles = document.querySelectorAll('.featured-articles');

if (featuredArticles.length) {
    [].forEach.call(featuredArticles, (swiperInstance) => {
        const slides = swiperInstance.querySelectorAll('.swiper-slide');
        if (slides.length !== 2) {
            [].forEach.call(slides, (slide) => {
                slide.classList.add('swiper-slide-count-3');
            });
        }

        const swipers = new Swiper(swiperInstance, {
            slidesPerView: 'auto',
            watchOverflow: true
        });
    });
}